export default "__VITE_ASSET__ByvqwgeU__"